var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container", staticStyle: { flex: "1" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showUp,
            expression: "showUp"
          }
        ],
        ref: "up",
        style: _vm.up
      },
      [_vm._t("up")],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showUp && _vm.showDown,
            expression: "showUp&&showDown"
          }
        ],
        ref: "division",
        staticClass: "division",
        style: { height: _vm.divisionH + "px" },
        on: {
          mousedown: function($event) {
            _vm.enabled = true
          }
        }
      },
      [
        _c("div", {
          staticClass: "line",
          staticStyle: { "margin-top": "2px" }
        }),
        _c("div", { staticClass: "line" })
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDown,
            expression: "showDown"
          }
        ],
        ref: "down",
        style: _vm.down
      },
      [_vm._t("down")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }